import { useState } from "react";
import Modal from "../../components/Modal";
import { api } from "../../services/api";

const INITIAL = {
  clientName: "",
  propertyAddress: "",
  transactionSide: "",
  compensationPlan: "Standard",
  salePrice: "",
  commissionRate: "",
  listingDate: "",
  contractDate: "",
  closingDate: "",
  notes: ""
};

export default function transactionIntakeModal({ workflow, user, agents, leadership, onClose, onSaved }) {
  const [form, setForm] = useState({
    ...INITIAL,
    transactionSide: workflow.side,
    agentEmail: user.email
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const set = key => event => setForm(current => ({ ...current, [key]: event.target.value }));
  const pending = ["under-contract", "pending-without-record"].includes(workflow.id);

  async function submit(event) {
    event.preventDefault();
    setSaving(true);
    setError("");
    try {
      await api.createTransaction({
        ...form,
        workflowId: workflow.id,
        transactionType: workflow.title
      });
      await onSaved();
    } catch (err) {
      setError(err.message);
      setSaving(false);
    }
  }

  return (
    <Modal title={workflow.title} onClose={onClose}>
      <form className="intake-form" onSubmit={submit}>
        {leadership && <label>Agent<select value={form.agentEmail} onChange={set("agentEmail")} required>
          {agents.map(agent => <option key={agent.email} value={agent.email}>{agent.name}</option>)}
        </select></label>}
        <label>Client name<input value={form.clientName} onChange={set("clientName")} required /></label>
        <label>Property address<input value={form.propertyAddress} onChange={set("propertyAddress")} required={workflow.id !== "buyer-agreement"} /></label>
        {!workflow.side && <label>Transaction side<select value={form.transactionSide} onChange={set("transactionSide")} required><option value="">Select</option><option>Buyer</option><option>Seller</option></select></label>}
        <label>Compensation plan<select value={form.compensationPlan} onChange={set("compensationPlan")}><option>Standard</option><option>Discount transaction</option></select></label>
        {(pending || leadership) && <div className="form-row"><label>Sale price<input type="number" min="0" step="0.01" value={form.salePrice} onChange={set("salePrice")} required={pending} /></label><label>Commission rate<input type="number" min="0" step="0.01" value={form.commissionRate} onChange={set("commissionRate")} /></label></div>}
        {workflow.id === "listing-agreement" && <label>Listing date<input type="date" value={form.listingDate} onChange={set("listingDate")} /></label>}
        {pending && <div className="form-row"><label>Contract date<input type="date" value={form.contractDate} onChange={set("contractDate")} required /></label><label>Closing date<input type="date" value={form.closingDate} onChange={set("closingDate")} required /></label></div>}
        <label>Notes<textarea rows="4" value={form.notes} onChange={set("notes")} /></label>
        {error && <div className="form-error">{error}</div>}
        <footer><button type="button" className="button ghost" onClick={onClose}>Cancel</button><button className="button primary" disabled={saving}>{saving ? "Submitting…" : "Submit to Operations"}</button></footer>
      </form>
    </Modal>
  );
}
